import React, { useContext } from 'react';

import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

// icon
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import ForgetPwd from '../forgetPwd/ForgetPwd';
import IconButton from '@material-ui/core/IconButton';

import { StyledSubmitButton } from '../../../components/button/Button';

// auth
import AuthService from '../../../services/auth.service';

// context
import UserContext from '../../../context/UserContext';
import ThaidRedirect from './ThaIDRedirect';

// style
import styles from './style';

const useStyles = makeStyles(styles);
export default function Login() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { setProfile } = useContext(UserContext);

  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const [isForget, setIsForget] = React.useState(false);
  const [isLogin, setIsLogin] = React.useState(true);

  const [state, setState] = React.useState({
    username: '',
    password: '',
    error: false,
    showPassword: false,
    rememberMe: false,
  });

  const getParamQuery = () => {
    const query = new URLSearchParams(window.location.search);
    return query.get('ref') !== null && query.get('ref') !== '' ? query.get('ref') : '/';
  };

  const onChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === 'rememberMe') {
      setState({ ...state, [name]: checked });
    } else {
      setState({ ...state, [name]: value });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const { username, password, rememberMe } = state;
    AuthService.login(username, password, rememberMe).then(
      () => {
        setState({ ...state, error: false });
        setProfile({ isLogin: true });
        forceUpdate();

        const currentRef = getParamQuery();
        if (currentRef !== '/') window.location.href = currentRef;
      },
      (error) => {
        const resMessage = (error.response
          && error.response.data
          && error.response.data.message)
          || error.message
          || error.toString();

        setState({ ...state, error: resMessage });
      },
    );
  };

  const handleClickShowPassword = () => {
    setState({ ...state, showPassword: !state.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  if (AuthService.isLogin()) {
    return false;
  }

  return (
    <>
      {isLogin && (
      <>
        <Box color="error.main" id="login-error">{state.error}</Box>
        <Grid container direction="column" spacing={0} style={{ marginTop: 10, paddingLeft: 5, paddingRight: 5 }}>
          <Grid item>
            <FormControl className={classes.customTextField}>
              <TextField
                name="username"
                id="username"
                defaultValue={state.username}
                onChange={onChange}
                label="บัญชีผู้ใช้งาน"
                variant="outlined"
              />
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl className={classes.customTextField}>
            <InputLabel htmlFor="outlined-adornment-password" style={{ marginLeft: 20, marginTop: -8 }}>รหัสผ่าน</InputLabel>
              <OutlinedInput
                name="password"
                id="password"
                type={state.showPassword ? 'text' : 'password'}
                defaultValue={state.password}
                onChange={onChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {state.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
                labelWidth={70}
              />
            </FormControl>
          </Grid>

          <Grid item>
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
              <FormControlLabel
                  className={{
                    root: classes.textLabel,  // Optional: Root element styles
                    label: classes.label,     // Apply custom styles to the label text
                  }}
                control={
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    name="rememberMe"
                    id="rememberMe"
                    checked={state.rememberMe}
                    onChange={onChange}
                    color="primary"
                  />
                }
                label="จดจำรหัสผ่าน"
              />
              <Button
                onClick={() => {
                  setIsForget(!isForget);
                  setIsLogin(!isLogin);
                }}
                className={classes.textLabel}
              >
                {t('ลืมรหัสผ่าน')}
              </Button>
            </Box>
          </Grid>
          <Grid item>
            <FormControl id="login-button" style={{ width: '100%', marginTop: 20, marginBottom: 20 }} onClick={onSubmit}>
              <StyledSubmitButton variant="contained" color="primary" style={{ borderRadius: 30, width: '100%' }}>{t('เข้าสู่ระบบ')}</StyledSubmitButton>
            </FormControl>
          
            <Box display="block" alignItems="center" justifyContent="center" my={3}>
              <ThaidRedirect />
            </Box>
          </Grid>
        </Grid>
      </>
      )}
      {isForget && (
        <>
          <NavigateBeforeIcon
            style={{ marginBottom: 10 }}
            onClick={() => {
              setIsLogin(true);
              setIsForget(false);
            }}
            id="back-button"
          />
          <ForgetPwd />
        </>
      )}
    </>
  );
}
